import { Status, Step } from '../types';
import { IFpsService } from './IFpsService';
import { logger } from '@common/logging/logger';

export class FpsServiceExceptionDecorator implements IFpsService {
  private decoree: IFpsService;

  constructor(decoree: IFpsService) {
    this.decoree = decoree;
  }

  async validateFloorplan(): Promise<void> {
    try {
      await this.decoree.validateFloorplan();
    } catch (err) {
      this.logError('validateFloorplan', err);
    }
  }

  async generateTracks(): Promise<void> {
    try {
      await this.decoree.generateTracks();
    } catch (err) {
      this.logError('generateTracks', err);
    }
  }

  async exportToRuntimeStack(
    generateTracks: boolean,
    generateProximityMatrix: boolean,
    generateTravelDurationCostMatrix: boolean,
  ): Promise<void> {
    try {
      await this.decoree.exportToRuntimeStack(
        generateTracks,
        generateProximityMatrix,
        generateTravelDurationCostMatrix,
      );
    } catch (err) {
      this.logError('exportToRuntimeStack', err);
    }
  }

  setStatus(status: Status): void {
    try {
      this.decoree.setStatus(status);
    } catch (err) {
      this.logError('setStatus', err);
    }
  }

  setStep(step: Step): void {
    try {
      this.decoree.setStep(step);
    } catch (err) {
      this.logError('setStep', err);
    }
  }

  reset(): void {
    try {
      this.decoree.reset();
    } catch (err) {
      this.logError('reset', err);
    }
  }

  private logError(methodName: string, error: unknown): void {
    logger.error(`FpsService.${methodName} failed:`, error);
  }
}
